import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ThumbsDown = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 20H20V25C20 26.654 18.654 28 17 28H16.354C15.12 28 14.027 27.26 13.569 26.114L10.323 18H7C5.346 18 4 16.654 4 15V7C4 5.346 5.346 4 7 4H21.877C24.176 4 26.17 5.557 26.728 7.787L27.97 12.757C27.99 12.836 28 12.918 28 12.999V16.999C28 18.653 26.654 19.999 25 19.999V20ZM6 7V15C6 15.551 6.449 16 7 16H10V6H7C6.449 6 6 6.449 6 7ZM26 13.123L24.787 8.272C24.452 6.934 23.256 6 21.877 6H12V16.807L15.425 25.371C15.578 25.753 15.942 25.999 16.354 25.999H17C17.551 25.999 18 25.55 18 24.999V18.999C18 18.447 18.448 17.999 19 17.999H25C25.551 17.999 26 17.55 26 16.999V13.122V13.123Z" />
	</svg>
);

export default ThumbsDown;
